module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTczbp9jAAAAIElEQVQYV2MAgv9ImOG/nZ3df2NjYwjH09Pzf2Rk5H8AwrsMMTX+5VIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/assets/img/1x1_panel.png
// module id = ../../../../../src/assets/img/1x1_panel.png
// module chunks = main